import React, { useEffect } from "react";
// import { Helmet } from "react-helmet";

import SEO from "../components/SEO";

import { useModifyFontsFunc } from "../hooks";

import { VisuallyHidden } from "@chakra-ui/react";

import { Nav } from ".././components/Nav";

import { SentenceBox } from "../components/Cards/ModifyCards/MainBlocks/SentenceBox";
import { SettingsBlock } from "../components/Cards/ModifyCards/MainBlocks/SettingsBlock";

// import Scale from "../components/Cards/ModifyCards/MainBlocks/Scale";
// import TypeScale from "../components/Cards/ModifyCards/TypeScale";

import {Adsense} from '@ctrl/react-adsense';

import { Head01 } from "../components/Cards/ModifyCards/Head01";
import { Head02 } from "../components/Cards/ModifyCards/Head02";
import { Head03 } from "../components/Cards/ModifyCards/Head03";
import { Head04 } from "../components/Cards/ModifyCards/Head04";
import { Head05 } from "../components/Cards/ModifyCards/Head05";
import { Head06 } from "../components/Cards/ModifyCards/Head06";

export const Font = () => {
  const {
    fontEdit,
    setFontEdit,
    sentenceEdit,
    handleSentenceChange,
    handleInputChange,
    handleOptionChange,
  } = useModifyFontsFunc();

  // Saving State Logic
  useEffect(() => {
    let data = localStorage.getItem("FontVars");
    if (data) {
      setFontEdit(JSON.parse(data));
    }
  }, [setFontEdit]);

  useEffect(() => {
    localStorage.setItem("FontVars", JSON.stringify(fontEdit));
  });

  const renderSettings = (id) => (
    <SettingsBlock
      id={id}
      placeSize={fontEdit[id].fonSize}
      placeHeight={fontEdit[id].fonHeight}
      placeSpacing={fontEdit[id].fonSpacing}
      handleInputChange={(e) => handleInputChange(e, id)}
      handleOptionChange={(e) => handleOptionChange(e, id)}
    />
  );
  return (
    <main>
      {/* SEO */}

      <SEO
        title="Font Scale | Felco ThemeGen"
        desc="Generate Type Scale and Typography Style guide for Design Systems"
        keywords="ThemeGen, Design System, create Design Systems, Style guide, design system software, theme.js, Theme Generator, Generate Themes, theme.js, type-scale, type scale, type scale generator, font scale, golden ratio, Font Visual Hierarchy, type, size, typography, typographic, typeface, px, scale, calculate, calculator, webfont, edit, update, modular scale, preview, typography style guide"
        url="https://themegen.netlify.app/font"
        type="website"
        img="https://felcoimg.netlify.app/img/fontscale.png"
      >
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6991856412998100"
        crossorigin="anonymous"></script>
      </SEO>
      {/**
      <Helmet>
        <title>Font Scale | Felco ThemeGen</title>
        <meta name="title" content="Font Scale | Felco ThemeGen"></meta>
        <meta
          name="description"
          content="Generate Type Scale and Font Visual Hierarchy"
        />
        <meta
          name="keywords"
          content="ThemeGen, Themeit, themify, Theme Generator, Generate Themes, theme.js, type-scale, type scale, type scale generator, font scale, golden ratio, Font Visual Hierarchy"
        />
        <link rel="canonical" href="https://themegen.netlify.app/font" />

        {/* Open Graph / Facebook  
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://themegen.netlify.app/font" />
        <meta property="og:title" content="Type Scale | Felco ThemeGen" />
        <meta
          property="og:description"
          content="Generate Type Scale and Font Visual Hierarchy"
        />
        {/* <meta property="og:image" content="" /> 

        {/* Twitter  
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://themegen.netlify.app/font"
        />
        <meta property="twitter:title" content="Type Scale | Felco ThemeGen" />
        <meta
          property="twitter:description"
          content="Generate Type Scale and Font Visual Hierarchy"
        />
        {/* <meta property="twitter:image" content="" /> 
      </Helmet>
       */}
      <Nav title="Font Scale" fontsPage />
      <SentenceBox handleSentenceChange={handleSentenceChange} />

      <VisuallyHidden>
        Felco Themegen | Font scale is a typographic scale and style guide
        template that helps you to visually calculate and preview the right size
        and line height for Fonts and modularly scale them and use it in your
        Design System or export directly to your project
      </VisuallyHidden>
      <Adsense
        client="ca-pub-6991856412998100"
        slot="1182937771" 
      />

      {/* <Scale  /> */}
      {/* <Portal>
        <Box position="fixed" bottom="20px" right="30px">
          <TypeScale />
        </Box>
      </Portal> */}

      <Head01
        id={0}
        side={fontEdit[0].side}
        sentence={sentenceEdit}
        fam={fontEdit[0].fonFam}
        size={fontEdit[0].fonSize}
        height={fontEdit[0].fonHeight}
        spacing={fontEdit[0].fonSpacing}
        weight={fontEdit[0].fonWeight}
        settings={renderSettings(0)}
      />
      <Head02
        id={1}
        side={fontEdit[1].side}
        sentence={sentenceEdit}
        fam={fontEdit[1].fonFam}
        size={fontEdit[1].fonSize}
        height={fontEdit[1].fonHeight}
        spacing={fontEdit[1].fonSpacing}
        weight={fontEdit[1].fonWeight}
        settings={renderSettings(1)}
      />
      <Head03
        id={2}
        side={fontEdit[2].side}
        sentence={sentenceEdit}
        fam={fontEdit[2].fonFam}
        size={fontEdit[2].fonSize}
        height={fontEdit[2].fonHeight}
        spacing={fontEdit[2].fonSpacing}
        weight={fontEdit[2].fonWeight}
        settings={renderSettings(2)}
      />
      <Head04
        id={3}
        side={fontEdit[3].side}
        sentence={sentenceEdit}
        fam={fontEdit[3].fonFam}
        size={fontEdit[3].fonSize}
        height={fontEdit[3].fonHeight}
        spacing={fontEdit[3].fonSpacing}
        weight={fontEdit[3].fonWeight}
        settings={renderSettings(3)}
      />
      <Head05
        id={4}
        side={fontEdit[4].side}
        sentence={sentenceEdit}
        fam={fontEdit[4].fonFam}
        size={fontEdit[4].fonSize}
        height={fontEdit[4].fonHeight}
        spacing={fontEdit[4].fonSpacing}
        weight={fontEdit[4].fonWeight}
        settings={renderSettings(4)}
      />
      <Head06
        id={5}
        side={fontEdit[5].side}
        fam={fontEdit[5].fonFam}
        size={fontEdit[5].fonSize}
        height={fontEdit[5].fonHeight}
        spacing={fontEdit[5].fonSpacing}
        weight={fontEdit[5].fonWeight}
        settings={renderSettings(5)}
      />
    </main>
  );
};
